import { IRole } from '~/store/user/types';
import { IUserRole } from '~/types';

const getIsGlobalUser = (roles?: IRole[], clinicId?: number): boolean =>
  !!(roles || [])
    .filter(role => (clinicId ? role.clinic?.id === clinicId : true))
    .find(role => role.name === IUserRole.GlobalUser);

export default getIsGlobalUser;
